import Switch from "react-switch";
import React, { Component, Fragment } from 'react';
import { Card, Form, Row, Col } from "react-bootstrap";

export default class UserInformation extends Component {

    state = {
        renderUser: false
    }

    renderSystemId = () => {
        if (this.props.isNewUser)
            return null
        else {
            return (
                <Fragment>
                    <Form.Label column sm="1" className="pull-right">System ID</Form.Label>
                    <Col sm='11'>
                        <Form.Control
                            type="text"
                            className="mb-3"
                            disabled={true}
                            value={this.props.formData.id}
                        />
                    </Col>
                </Fragment>
            )
        }
    }

    render() {
        return (
            <Card>
                <Card.Header>User Information</Card.Header>
                <Card.Body>
                    <Form >
                        <Form.Group as={Row}>
                            {this.renderSystemId()}
                            <Form.Label column sm="1" className="pull-right">Name</Form.Label>
                            <Col sm='11'>
                                <Form.Control
                                    type="text"
                                    className="mb-3"
                                    value={this.props.formData.name}
                                    onChange={(e) => this.props.formActions.setName(e.target.value)}
                                />
                            </Col>

                            <Form.Label column sm="1" className="pull-right">Active Directory ID</Form.Label>
                            <Col sm='11'>
                                <Form.Control
                                    type="text"
                                    className="mb-3"
                                    value={this.props.formData.adId}
                                    onChange={(e) => this.props.formActions.setAdId(e.target.value)}
                                />
                            </Col>

                            <Form.Label column sm="1" className="pull-right">Email</Form.Label>
                            <Col sm='11'>
                                <Form.Control
                                    type="text"
                                    className="mb-3"
                                    value={this.props.formData.email}
                                    onChange={(e) => this.props.formActions.setEmail(e.target.value)}
                                />
                            </Col>

                            <Form.Label column sm="1" className="pull-right">Mail Stop</Form.Label>
                            <Col sm='11'>
                                <Form.Control
                                    type="text"
                                    className="mb-3"
                                    value={this.props.formData.mailStop}
                                    onChange={(e) => this.props.formActions.setMailStop(e.target.value)}
                                />
                            </Col>

                            <Col sm={3}></Col>
                            <Col>
                                <p>Receive Notifications?</p>
                                <Switch
                                    checked={this.props.formData.sendEmail}
                                    onChange={(checked) => this.props.formActions.setSendEmail(checked)}
                                />
                            </Col>
                            <Col>
                                <p>Is Active?</p>
                                <Switch
                                    checked={this.props.formData.active}
                                    onChange={(checked) => this.props.formActions.setActive(checked)}
                                />
                                <Form.Text>Allows user to gain access to this system.</Form.Text>
                            </Col>

                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card>
        );
    }
}
